import { createAction, props } from '@ngrx/store';
import { ErrorContext, ICatalogInfo, LoginError, Version } from '@ra-state';
import { UserProfile } from '@rockwell-automation-inc/common-utils';

export const incrementReqs = createAction('[CONTROL_PAGE] Increment Reqs');
export const decrementReqs = createAction('[CONTROL_PAGE] Decrement Reqs');

export const userLoginComplete = createAction('[CONTROL_PAGE] UserLoggedIn', props<{ payload: UserProfile }>());
export const userLoginFailed = createAction('[CONTROL_PAGE] UserLoginFailed', props<{ payload: LoginError }>());
export const logoutSession = createAction('[CONTROL_PAGE] logoutSession');

export const navigateTo = createAction('[Navigate] Navigate To Route', props<{ path: string }>());

export const navigateToError = createAction('[Error] Navigate To Error', props<{ payload: ErrorContext }>());

export const setErrorContext = createAction('[Error] Set Error Context', props<{ payload: ErrorContext }>());

export const getVersions = createAction('[APIVersion] Get Version');

export const setVersions = createAction('[APIVersion] Set Version', props<{ value: Version }>());

export const getProductCatalog = createAction('[CATALOG] Get Catalog Info');
export const setProductCatalogSuccess = createAction(
  '[CATALOG] Get Catalog Info Success',
  props<{ payload: ICatalogInfo[] }>(),
);

export const emptyAction = createAction('[EMTPY] Empty Action');

export const startAppInitializer = createAction('[App] Starting App');

export const AppInitFinished = createAction('[App] Rockwell-automation-inc library loaded');

export const permissionDenied = createAction(
  '[PERMISSION] Permission Denied',
  props<{ errorMessage: string; handleRedirectOnDenied?: () => void }>(),
);
